module.exports = __webpack_public_path__ + "images/aller-logo-black_8fed5344ccbb4ccd068c222ad32dea66.svg";